import { CustomException } from '@tencent/ppd-base-libs';
import { queryDpMessage } from '@tencent/wphk-components-dp-loader';
import { to } from '@tencent/wphk-base-utils';
import { BannerConfig } from '../types';
import { getConfigWithLang, getJumpUrl } from '../utils/format-lang';
import { defaultTransformer } from '../business';
import { BannerJumpDpConfig } from '../types/dp-banner';
/**
 * 根据投放中台页面 id，位置 id 获取投放计划
 */
export const initDpBanner = async (dpPageId: string, dpPositionId: string, transformer = defaultTransformer) => {
  // 从投放中台查询信息
  const [error, dpMsg] = await to(queryDpMessage({
    dpPage: dpPageId,
    dpPositions: [dpPositionId],
  }));
  if (error || !dpMsg) {
    new CustomException(error, 'DpLoaderException', `loader failed for dpPage: ${dpPageId}, dpPosition: ${dpPositionId}`);
    return [];
  }
  const config = formatBannerTag(dpMsg.dpList.map(item => item.contentBaseData as any));
  // 可由外部注册过滤逻辑
  return transformer(config);
};

const formatBannerTag = (list: BannerJumpDpConfig[]): BannerConfig[] => {
  const formattedList = getConfigWithLang({
    originalObj: list,
    configKey: ['imgObj', 'bannerAltObj'],
  });
  return formattedList.map(ele => ({
    /* banner图片地址 */
    bannerImgUrl: ele.imgObj,
    /* banner的tag，用于bi上报区分 */
    bannerTag: ele.statClick,
    /** 点击banner跳转信息 */
    bannerJumpInfo: {
      jumpUrl: (getJumpUrl(ele) || ele.link) ?? '',
      miniAppId: ele.appid ?? '',
      miniAppUsername: ele.username ?? '',
      miniAppPath: ele.path ?? '',
    },
    /** 无障碍 */
    bannerAlt: ele.bannerAltObj ?? '',
    /** 排序权重 */
    weight: 0,
    /** 额外传入数据 */
    extraData: ele.customEventKey,
    /** 投放中台返回的原对象，用于处理返回额外字段的场景 */
    originalData: ele,
  }));
};
